<div class="base tab-content d-flex flex-column" [ngClass]="{ 'hidden' : !newVersion, 'shown' : newVersion  }">

    <div class="title p-2">{{ 'reload-app' | translate }}</div>
    <img class="reload" src="assets/icons/refresh_white.svg" (click)="reloadAppClick()"/>
</div>
